module.exports = __webpack_public_path__ + "img/fullscreen.76411aeb.svg";